import { render, staticRenderFns } from "./accordion-item.html?vue&type=template&id=92be8d82&"
import script from "./accordion-item.js?vue&type=script&lang=js&"
export * from "./accordion-item.js?vue&type=script&lang=js&"
import style0 from "./accordion-item.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports